// Helper to format time as 12-hour am/pm
export function formatTimeTo12Hour(timeStr) {
  if (!timeStr) return '-';
  const [hour, minute] = timeStr.split(":");
  if (hour === undefined || minute === undefined) return timeStr;
  const h = parseInt(hour, 10);
  const ampm = h >= 12 ? "pm" : "am";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}${minute !== "00" ? ":" + minute : ""}${ampm}`;
}

// Helper to format date as MM/DD/YYYY
export function formatDateMMDDYYYY(dateStr) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}

// Helper to add days to a YYYY-MM-DD string in local time
export function addDaysToDate(dateStr, days) {
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

// Format date as 'Thursday, May 29, 2025'
export function formatDateLong(dateStr) {
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
} 